import { render, staticRenderFns } from "./StepLicense.vue?vue&type=template&id=25f5f6e2&scoped=true&"
import script from "./StepLicense.vue?vue&type=script&lang=ts&"
export * from "./StepLicense.vue?vue&type=script&lang=ts&"
import style0 from "./StepLicense.vue?vue&type=style&index=0&id=25f5f6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f5f6e2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f5f6e2')) {
      api.createRecord('25f5f6e2', component.options)
    } else {
      api.reload('25f5f6e2', component.options)
    }
    module.hot.accept("./StepLicense.vue?vue&type=template&id=25f5f6e2&scoped=true&", function () {
      api.rerender('25f5f6e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/wizard/StepLicense.vue"
export default component.exports